import { render, staticRenderFns } from "./Att.vue?vue&type=template&id=452a0390&scoped=true&"
import script from "./Att.vue?vue&type=script&lang=js&"
export * from "./Att.vue?vue&type=script&lang=js&"
import style0 from "./Att.vue?vue&type=style&index=0&id=452a0390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a0390",
  null
  
)

export default component.exports